import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './TopBarContainer.css';
import SaveState from './../top-bar-buttons/save-state/saveState';
import Colors from './../top-bar-buttons/colors/Colors';
import {
  GetActivePage,
  hideComponent,
} from './../../../redux/helpers';

import DateStyle from '../top-bar-buttons/date-style/DateStyle';

class TopBarContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hideComponentInAutofill: false,
      hideTopBar: false,
    };
  }

  componentWillMount() {
    if (hideComponent()) {
      this.setState({
        hideComponentInAutofill: true,
      });
    }
  }


  activePage = () => {
    const { byId } = this.props.pages;
    return Object.values(byId).find(element => element.isActive);
  }

  isInnerPage = () => {
    const { isCover } = this.activePage();
    return isCover;
  }

  renderComponents = () => {
    const { hideComponentInAutofill, hideTopBar } = this.state;

    const {
      pages,
      lang,
      coverType,
      calendarStartYear,
      calendarStartMonth,
    } = this.props;

    if (hideComponentInAutofill || hideTopBar) {
      return false;
    }

    const activePage = GetActivePage(pages.byId);
    return (
      <div>

        <Colors
          isCover={activePage.isCover}
          pageId={activePage.id}
          pageOrder={activePage.order}
          pages={pages.allIds}
          lang={lang}
          coverType={coverType}
        />
        { calendarStartYear !== 0 && calendarStartMonth !== 0 && <DateStyle
          lang={lang}
          pageId={activePage.id}
          pageOrder={activePage.order}
          pages={pages.allIds}
          calendarStartYear={calendarStartYear}
          calendarStartMonth={calendarStartMonth}
        />
        }
        { /* <InsertText
          lang={lang}
          pageId={activePage.id}
          isTextLayout={this.isInnerPage()}
          coverType={coverType}
        /> */
        }
        { /* <Help lang={lang} /> */}
      </div>
    );
  }

  render() {
    const {
      lang,
      bookId,
    } = this.props;

    const { hideComponentInAutofill } = this.state;

    return (
      <div className="Topbar-wrapper">
        { this.renderComponents() }
        <div className="last-elements">
          <SaveState
            lang={lang}
            hideComponent={hideComponentInAutofill}
            bookId={bookId}
          />
        </div>
      </div>
    );
  }
}

TopBarContainer.defaultProps = {
  pages: {},
  lang: {},
  bookId: 1,
  coverType: 'fotos',
};

TopBarContainer.propTypes = {
  pages: PropTypes.object,
  lang: PropTypes.object,
  bookId: PropTypes.number,
  coverType: PropTypes.string,
};

export default connect(state => ({
  pages: state.entities.pages,
  isChange: state.editorUI.imageChange.isChange,
  pageBackgroundColor: state.editorUI.bookProperties.backgroundColor,
  pageBackgroundImage: state.editorUI.bookProperties.backgroundImage,
  pageBackgroundImageFull: state.editorUI.bookProperties.backgroundImageFull,
  sizes: state.editorUI.bookProperties.backgroundSize,
  bookId: state.bookProperties.calendarId,
  coverType: state.bookProperties.cover.type,
  ratio: state.bookProperties.bookSizes.ratio,
  calendarStartYear: state.bookProperties.calendarStartYear,
  calendarStartMonth: state.bookProperties.calendarStartMonth,
}))(TopBarContainer);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-container/TopBarContainer.jsx